import { Experiments } from 'CustomOptimizelyProvider'
import RootStore from 'stores/RootStore'
import { COOKIE_KEY_FCID, getCookie } from 'utils/cookie'
import { trackTeal } from 'utils/tracking'
import { PossibleVariants } from 'utils/tracking/optimizely/types'

export const isWithinWorkingHours = () => {
  const date = new Date()
  const day = date.getDay()
  const month = date.getMonth() + 1 // getMonth(): 0 = Jan → +1 to make it human-readable
  const dayOfMonth = date.getDate()

  // Holiday closures
  const isHoliday =
    (month === 12 && [24, 25, 26, 31].includes(dayOfMonth)) ||
    (month === 1 && dayOfMonth === 1)

  if (isHoliday) {
    return false
  }

  const minutesSinceMidnight = date.getHours() * 60 + date.getMinutes()

  // Define working hour ranges in minutes
  const weekdayStart = 8 * 60 + 30 // 08:30
  const weekdayEnd = 19 * 60 + 30 // 19:30

  const saturdayStart = 10 * 60 + 30 // 10:30
  const saturdayEnd = 17 * 60 + 30 // 17:30

  if (day >= 1 && day <= 5) {
    // Monday–Friday
    return (
      minutesSinceMidnight >= weekdayStart && minutesSinceMidnight <= weekdayEnd
    )
  }

  if (day === 6) {
    // Saturday
    return (
      minutesSinceMidnight >= saturdayStart &&
      minutesSinceMidnight <= saturdayEnd
    )
  }

  // Sunday → always closed
  return false
}

export const isPremiumCustomerAndWorkingHour = (
  rootStore: RootStore
): boolean => {
  const isWorkingHoursCorrect = isWithinWorkingHours()
  const {
    traversal: {
      data: {
        common: { amount },
        debtors: {
          primary: {
            income: { primary }
          }
        }
      }
    }
  } = rootStore
  return isWorkingHoursCorrect && amount >= 25000 && primary >= 2800
}

export const trackPremiumAndTimingEvents = (rootStore: RootStore) => {
  const {
    experimentData,
    traversal: {
      data: {
        system: { advertisementId },
        common: { amount },
        debtors: {
          primary: {
            income: { primary }
          }
        }
      }
    }
  } = rootStore

  const isInAnyVariation =
    // @ts-ignore - experimentData type needs refinement for dynamic access
    experimentData[Experiments.CAT_4015_PREMIUM_CALL] ===
      PossibleVariants.CONTROL ||
    // @ts-ignore - experimentData type needs refinement for dynamic access
    experimentData[Experiments.CAT_4015_PREMIUM_CALL] ===
      PossibleVariants.VARIATION_B

  if (isInAnyVariation) {
    const isWorkingHours = isWithinWorkingHours()
    trackTeal({
      transaction: {
        event: isWorkingHours
          ? 'premium_call_working_hour_yes'
          : 'premium_call_working_hour_no'
      },
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        userAttributes: {
          advertisementId
        }
      }
    })
    const isInPremium = amount >= 25000 && primary >= 2800
    trackTeal({
      transaction: {
        event: isInPremium
          ? 'premium_call_income_amount_yes'
          : 'premium_call_income_amount_no'
      },
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        userAttributes: {
          advertisementId
        }
      }
    })
    if (isWorkingHours && isInPremium) {
      trackTeal({
        transaction: {
          event: 'premium_call_income_amount_working_hour_yes'
        },
        context: {
          Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
          userAttributes: {
            advertisementId
          }
        }
      })
    }
  }
}
